// removed by extract-text-webpack-plugin
module.exports = {"fullDiv":"client-containers-App-styles__fullDiv___2gKP7","sky":"client-containers-App-styles__sky___3vs8k"};


//////////////////
// WEBPACK FOOTER
// ./client/containers/App/styles.css
// module id = 407
// module chunks = 0